import storage from '../../../../../hooks/useStorage/useStorage';
import LangEnum from '../../../../../lang/LangEnum';
import useGeneralSettingsStore from '../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { HTTP_STATUS } from '../../../../../utils/httpStatus.const';
import { ValidateCatalogSectionItemForCustomerCatalogsUtils } from '../../../offlineRequestAdapters/utils/validateCatalogSectionItemForCustomerCatalogs.utils';
import { offlineUsersRepository } from '../../../repositories/offlineUsers.repository';
import { createApiSauceResponse } from '../../../utils/createApiSauceResponse.util';
import {
  ValidateIfCustomerHasAccessToOrderProductsParams,
  ValidateSellerCanCreateOrUpdateOrderWithoutCustomerParams,
} from './types/offlineOrder.utils.types';

export const validateSellerCanCreateOrUpdateOrderWithoutCustomer = ({
  blockOrderWithoutCustomer,
  customerId,
}: ValidateSellerCanCreateOrUpdateOrderWithoutCustomerParams) => {
  const teamId = storage.getTeamId();
  const userTeam = offlineUsersRepository.getUserTeam(teamId);

  if (!userTeam) {
    throw new Error('team not found');
  }

  const isStore = userTeam.role === 'ADMIN_LOJA' || userTeam.role === 'COMPRADOR';
  if (!customerId && isStore) {
    throw new Error('Cannot create or update order without customer');
  }

  const isSeller = userTeam.role === 'VENDEDOR';
  if (blockOrderWithoutCustomer && !customerId && isSeller) {
    throw new Error('Cannot create or update order without customer');
  }
};

export const validateIfCustomerHasAccessToOrderProducts = async ({
  customerId,
  orderId,
}: ValidateIfCustomerHasAccessToOrderProductsParams) => {
  const brandGeneralSettings = useGeneralSettingsStore.getState().generalSettings;
  const restrictProductsUsingCustomerCatalogs =
    !!brandGeneralSettings.restrictProductsUsingCustomerCatalogs;

  const customerHasAccessTo =
    await ValidateCatalogSectionItemForCustomerCatalogsUtils.validateCustomerOnOrder({
      customerId: customerId,
      orderId: orderId,
      restrictProductsUsingCustomerCatalogs,
    });

  if (!customerHasAccessTo) {
    const response = createApiSauceResponse({
      ok: false,
      data: {
        code: LangEnum.API_EXCEPTION_CUSTOMER_UNAUTHORIZED_ORDER_PRODUCTS,
        message: 'o cliente não tem acesso aos produtos do pedido',
        status: HTTP_STATUS.UNPROCESSABLE_ENTITY,
      },
    });

    throw response;
  }
};
